module.exports = __webpack_public_path__ + "static/manuscrit-21954ebaf008cabdf8a42bdd05d9b00c.jpg";